module.exports = __webpack_public_path__ + "img/307.f34650b3.jpg";